export class PageUrl {

    map = new Map([
        //hr-routings
        ['testflightshrweb', 'testflightshrweb'],
        ['employment', 'hr/employment'],
        ['personal', 'hr/personal'],
        ['education', 'hr/education'],
        ['experience', 'hr/experience'],
        ['empStatutory', 'hr/empStatutory'],
        ['reference', 'hr/reference'],
        ['bgCheck', 'hr/bgCheck'],
        ['documents', 'hr/documents'],
        ['letters', 'hr/letters'],
        ['salary', 'hr/salary'],
        ['attendance', 'hr/attendance'],
        ['leaveLoanExpense', 'hr/leaveLoanExpense'],
        ['leave', 'hr/leave'],
        ['loan', 'hr/loan'],
        ['expense', 'hr/expense'],
        ['performanceSetUp', 'hr/performanceSetUp'],
        ['foodCouponAllocate', 'hr/foodCouponAllocate'],
        ['assetAllocation', 'hr/assetAllocation'],
        ['accomodation', 'hr/accomodation'],
        ['setKRA', 'hr/setKRA'],

        //HR-Policy SetUp
        ['docsetup', 'hr/docsetup'],
        ['companydocs', 'hr/companydocs'],
        ['statutorySetUp', 'hr/statutorySetUp'],
        ['payrollSetup', 'hr/payrollSetup'],
        ['taxSetup', 'hr/taxSetup'],
        ['empGroups', 'hr/empGroups'],
        ['jdSetUp', 'hr/jdSetUp'],
        ['scheduleSetUp', 'hr/scheduleSetUp'],
        ['overTimeSetUp', 'hr/overTimeSetUp'],
        ['attendanceSetUp', 'hr/attendanceSetUp'],
        ['leaveSetUp', 'hr/leaveSetUp'],
        ['expenseSetUp', 'hr/expenseSetUp'],
        ['loanSetUp', 'hr/loanSetUp'],
        ['pmsSetUp', 'hr/pmsSetUp'],
        ['foodCouponSetUp', 'hr/foodCouponSetUp'],
        ['exitSetUp', 'hr/exitSetUp'],
        ['accommodationSetUp', 'hr/accommodationSetUp'],
        ['hoildaySetUp', 'hr/hoildaySetUp'],
        ['encashmentSetUp', 'hr/encashmentSetUp'],

        //HR-Employee Attendance
        ['markAttendance', 'hr/markAttendance'],
        ['manualAttendance', 'hr/manualAttendance'],
        ['systemAttendance', 'hr/systemAttendance'],
        ['attendanceCorrection', 'hr/attendanceCorrection'],
        ['attendanceRegularization', 'hr/attendanceRegularization'],

        //HR-Leave
        ['requestLeave', 'hr/requestLeave'],

        //HR-Payroll
        ['salaryProcessing', 'hr/salaryProcessing'],
        ['tdsCalculation', 'hr/tdsCalculation'],
        ['overtimeCalculation', 'hr/overtimeCalculation'],
        ['incentiveCalculation', 'hr/incentiveCalculation'],
        ['bonusCalculation', 'hr/bonusCalculation'],
        ['claims', 'hr/claims'],
        ['deduction', 'hr/deduction'],
        ['reimbursements', 'hr/reimbursements'],
        ['arrears', 'hr/arrears'],
        ['leaveEncashments', 'hr/leaveEncashments'],
        ['paySlips', 'hr/paySlips'],
        ['incomeTax', 'hr/incomeTax'],
        ['gratuity', 'hr/gratuity'],

        //HR-Expense
        ['advanceForExpense', 'hr/advanceForExpense'],
        ['requestExpenseClaim', 'hr/requestExpenseClaim'],

        //HR-Loans
        ['requestLoan', 'hr/requestLoan'],
        ['approveLoanRequest', 'hr/approveLoanRequest'],

        //HR-Food Coupons
        ['couponReport', 'hr/couponReport'],

        //HR-Communication
        ['messaging', 'hr/messaging'],

        //HR-Appriasal
        ['appraisal', 'hr/appraisal'],
        ['issueResolution', 'hr/issueResolution'],

        //HR-Recritement
        ['postRequirement', 'hr/postRequirement'],
        ['cvBank', 'hr/cvBank'],
        ['shortlist', 'hr/shortlist'],
        ['scheduleInterview', 'hr/scheduleInterview'],
        ['interviewFeedback', 'hr/interviewFeedback'],
        ['confirmation', 'hr/confirmation'],

        //HR-Exit
        ['initiateExit', 'hr/initiateExit'],
        ['exitInterview', 'hr/exitInterview'],
        ['exit', 'hr/exit'],


        //Store-Operation
        ['Staff', 'store-operation/manage-staff/staff'],
        ['Shift', 'store-operation/manage-staff/shift'],
        ['Store-Attendance', 'store-operation/attendance/store-attendance'],
        ['Staff-Attendance', 'store-operation/attendance/staff-attendance'],
        ['Floor-SM', 'store-operation/store-care/floor-sm'],
        ['Front-Glass', 'store-operation/store-care/front-glass'],
        ['Display-Rack', 'store-operation/store-care/display-rack'],
        ['Display-Freezer', 'store-operation/store-care/display-freezer'],
        ['Deep-Freezer', 'store-operation/store-care/deep-freezer'],
        ['Machine', 'store-operation/store-care/machine'],
        ['Equipment', 'store-operation/store-care/equipment'],
        ['Signage', 'store-operation/store-care/signage'],
        ['Approve-Attendance', 'store-operation/store-approval/approve-attendance'],
        ['Approve-Store-Care', 'store-operation/store-approval/approve-store-makeup'],
        ['B2B-Customers', 'store-operation/wholesale-customer/b2b-customers'],
        ['Approve-B2B-Customers', 'store-operation/wholesale-customer/approve-b2b-customers'],
        ['Raise-Issue', 'store-operation/store-feedback/raise-issue'],
        ['Store-Reporting', 'store-operation/store-reporting/store-reporting'],

        //Sale
        ['AdvanceReceiptSaleInvoice', 'sale/invoice/advance-receipt'],
        ['AdvanceReceipt', 'sale/invoice/advance-receipt'],
        ['Credit-DebitNote-Sale-Invoice-Sales', 'sale/invoice/credit-or-debit-note'],
        ['Credit-DebitNote-Sale-GST', 'sale/invoice/credit-or-debit-note'],
        ['ExportInvoice-Sale-Invoice-Sales', 'sale/invoice/export-invoice'],
        ['ExportInvoice-Sale-GST', 'sale/invoice/export-invoice'],
        ['InvoicecumBillOfSupply', 'sale/invoice/invoice-cum-bill-of-supply'],
        ['Invoice-Cum-BillOfSupply', 'sale/invoice/invoice-cum-bill-of-supply'],
        ['BillOfSupply-Sale-Invoice', 'sale/invoice/bill-of-supply'],
        ['BillOfSupply-Sale-GST', 'sale/invoice/bill-of-supply'],
        ['SaleInvoice-Sale-Invoice-Sales', 'sale/invoice/sale-invoice'],
        ['SaleInvoice-Sale-GST', 'sale/invoice/sale-invoice'],
        ['Proforma-Invoice', 'sale/invoice/proforma-invoice'],
        ['Quotation', 'sale/invoice/quotation'],
        ['POS', 'sale/pos/pos'],
        ['POS-android', 'sale/pos/pos-web-app'],
        ['ManageBills', 'sale/pos/manage-bills'],
        ['Bill', 'sale/pos/make-to-order-bill'],
        ['Coupon-Redemption', 'sale/pos/coupon-redemption'],

        //Purchase
        ['AdvancePaymentPurchaseInvoice', 'purchase/invoice/advance-payment'],
        ['AdvancePayment', 'purchase/invoice/advance-payment-gst'],
        ['PurchaseBillOfSupply-Purchase-Invoice', 'purchase/invoice/purchase-bill-of-supply'],
        ['PurchaseBillOfSupply-Purchase-GST', 'purchase/invoice/purchase-bill-of-supply-gst'],
        ['Cdnr-Purchase-Invoice', 'purchase/invoice/purchase-cdnr'],
        ['CdnurPurchaseInvoice', 'purchase/invoice/purchase-cdnur'],
        ['Cdnr-Purchase-GST', 'purchase/invoice/purchase-cdnr-gst'],
        ['Cdnur-Purchase-GST', 'purchase/invoice/purchase-cdnur-gst'],
        ['Purchase-Order', 'purchase/invoice/purchase-order'],
        ['ImportInvoice-Purchase-Invoice', 'purchase/invoice/import-invoice'],
        ['ImportInvoice-Purchase', 'purchase/invoice/import-invoice-gst'],
        ['B2BPurchaseInvoice', 'purchase/invoice/b2b'],
        ['B2BGSTPurchase', 'purchase/invoice/b2b-gst'],
        ['B2BUR', 'purchase/invoice/b2bur'],
        ['B2BUR-GST-Purchase', 'purchase/invoice/b2bur-gst'],




        //Order
        ['Others-OrderStock', 'order/order/others'],
        ['Scrap-OrderStock', 'order/order/scrap'],
        ['CapitalGoods-OrderStock', 'order/order/capitalgoods'],
        ['TradeGoods-OrderStock', 'order/order/tradegoods'],
        ['FinishedGoods-OrderStock', 'order/order/finishedgoods'],
        ['SemiFinishedGoods-OrderStock', 'order/order/semifinishedgoods'],
        ['RawMaterials-OrderStock', 'order/order/rawmaterialsOrderStock'],
        ['Create-Order', 'order/order/make-to-order'],

        ['CapitalGoods-Receive', 'order/receive/receivecapitalgoods'],
        ['FinishedGoods-Receive', 'order/receive/receivefinishedgoods'],
        ['Others-Receive', 'order/receive/receiveothers'],
        ['RawMaterials-Receive', 'order/receive/receiverawmaterials'],
        ['Scrap-Receive', 'order/receive/receivescrap'],
        ['SemiFinishedGoods-Receive', 'order/receive/receivesemifinishedgoods'],
        ['TradeGoods-Receive', 'order/receive/receivetradegoods'],
        ['Receive-Make-To-Order', 'order/receive/receive-make-to-order'],

        ['CrateCount', 'order/crate/cratecount'],
        ['Receive', 'order/crate/managecratesreceive'],
        ['Send', 'order/crate/managecratessend'],

        ['deliverygoods', 'order/delivery/delivery-goods'],
        ['delivery-summary', 'order/delivery/delivery-summary'],
        ['vehicle-reports', 'order/delivery/vehicle-reports'],
        ['holding-time-report', 'order/delivery/holding-time-report'],

        ['FinishedGoods-Dispatch', 'order/dispatch/dispatchfinishedgoods'],
        ['Others-Dispatch', 'order/dispatch/dispatchothers'],
        ['RawMaterials-Dispatch', 'order/dispatch/dispatchrawmaterials'],
        ['Scrap-Dispatch', 'order/dispatch/dispatchscrap'],
        ['SemiFinishedGoods-Dispatch', 'order/dispatch/dispatchsemifinished'],
        ['CapitalGoods-Dispatch', 'order/dispatch/dispatchtcapitalgoods'],
        ['TradeGoods-Dispatch', 'order/dispatch/dispatchtradegoods'],
        ['Dispatch-Make-To-Order', 'order/dispatch/dispatch-make-to-order'],

        ['Process-Make-To-Order', 'order/process/processmaketoorder'],
        ['ProcessOrder', 'order/process/processorder'],
        ['ProductOrders', 'order/process/productorders'],
        ['SavedOrders', 'order/process/savedorders'],

        ['CapitalGoods-ReceiveGoodsReturn', 'order/receive-return/receivegoodsreturn-capitalgoods'],
        ['FinishedGoods-ReceiveGoodsReturn', 'order/receive-return/receivegoodsreturn-finishedgoods'],
        ['Others-ReceiveGoodsReturn', 'order/receive-return/receivegoodsreturn-others'],
        ['RawMaterials-ReceiveGoodsReturn', 'order/receive-return/receivegoodsreturn-rawmaterials'],
        ['Scrap-ReceiveGoodsReturn', 'order/receive-return/receivegoodsreturn-scrapgoods'],
        ['SemiFinishedGoods-ReceiveGoodsReturn', 'order/receive-return/receivegoodsreturn-semifinishedgoods'],
        ['TradeGoods-ReceiveGoodsReturn', 'order/receive-return/receivegoodsreturn-tradegoods'],
        ['Receive-Return-Make-To-Order', 'order/receive-return/receive-return-make-to-order'],

        ['CapitalGoods-GoodsReturn', 'order/return/goodsReturnCapitalGoods'],
        ['FinishedGoods-GoodsReturn', 'order/return/goodsReturnFinishedGoods'],
        ['Others-GoodsReturn', 'order/return/goodsReturnOthers'],
        ['RawMaterials-GoodsReturn', 'order/return/goodsReturnRawMaterials'],
        ['Scrap-GoodsReturn', 'order/return/goodsReturnScrap'],
        ['SemiFinishedGoods-GoodsReturn', 'order/return/goodsReturnSemiFinishedGoods'],
        ['TradeGoods-GoodsReturn', 'order/return/goodsReturnTradeGoods'],
        ['Return-Make-To-Order', 'order/return/return-make-to-order'],

        ['ManageOrders', 'order/shipping-management/manageorders'],
        ['manage-shipping', 'order/shipping-management/shipping-manager'],

        ['Track-Service-Man', 'order/track/track-service-man'],
        ['Track-Vehicle', 'order/track/track-vehicle'],

        ['b2b-orders', 'order/web-order/b2b-orders'],
        ['Orders', 'order/web-order/weborder'],
        ['DispatchToStore', 'order/web-order/dispatch-to-store'],
        ['DeliveryAtStore', 'order/web-order/delivery-at-store'],
        ['PickupAtStore', 'order/web-order/pickup-at-store'],
        ['CustomizedOrders', 'order/web-order/customized-orders'],
        ['UnfulfilledOrders', 'order/web-order/unfulfilled-orders'],
        ['EditOrders', 'order/web-order/edit-orders'],
        ['WeborderException', 'order/web-order/weborder-exception'],
        ['Platforms-Dashboard', 'order/web-order/platforms-dashboard'],
        ['Capital-Foods', 'order/web-order/platforms-kds'],
        ['Platforms-Returns', 'order/web-order/platforms-return'],
        ['Platforms-Stock', 'order/web-order/platforms-stock'],

        //Inventory
        ['ManageBOM', 'inventory/inventory-control/bill-of-material'],
        ['Stock-Count', 'inventory/inventory-control/stock-count'],
        ['Wastage', 'inventory/inventory-control/wastage'],
        ['View-Stock', 'inventory/inventory-control/view-stock'],

        ['Receive-Stock', 'inventory/stock-flow/receive-stock'],
        ['Issue-Stock', 'inventory/stock-flow/issue-stock'],
        ['Indent-Stock', 'inventory/stock-flow/indent-stock'],

        ['warehouse-history', 'inventory/warehouse/warehouse-history'],
        ['occupancy', 'inventory/warehouse/occupancy'],
        ['locate', 'inventory/warehouse/locate'],
        ['track-storage', 'inventory/warehouse/track-storage'],
        ['store-in', 'inventory/warehouse/store-in'],
        ['store-out', 'inventory/warehouse/store-out'],

        //Production
        ['SemiFinishedOrders', 'production/manage-production/semi-finished-orders'],
        ['FinishedOrders', 'production/manage-production/finished-orders'],
        ['MakeToOrders-Production', 'production/manage-production/make-to-orders'],

        ['Production-Planning', 'production/organise-production/production-planning'],

        ['Production-Loss', 'production/production-loss/production-loss'],

        ['Orders-View-Order', 'production/view-order/orders-view-order'],
        ['MakeToOrders-View-Order', 'production/view-order/make-to-orders-view-order'],

        ['Manage-Quality-Process', 'process/manage/quality-process'],
        ['Manage-Audit-Process', 'process/manage/audit-process'],
        ['Manage-OnBoarding-Process', 'process/manage/on-boarding-process'],
        ['Manage-Research-And-Development-Process', 'process/manage/research-and-development-process'],
        ['Manage-Mock-Drill-Process', 'process/manage/mock-drill-process'],
        ['Manage-General-Process', 'process/manage/general-process'],
        ['Manage-Other-Process', 'process/manage/other-process'],
        ['Manage-Product-Process', 'process/manage/production-process'],

        ['Schedule-Product-Process', 'process/schedule/product-schedule'],

        //Account
        ['Costing', 'account/costing-and-budgeting/costing'],

        ['Expense-Approval', 'account/expenses/expense-approval'],
        ['Expense-Payment', 'account/expenses/expense-payment'],
        ['hr-expenses', 'account/expenses/hr-expenses'],
        ['cumulative-salary', 'account/expenses/cumulative-salary'],

        ['GroupAndSubGroupAccounts', 'account/ledger/group-and-subgroup-accounts'],
        ['SubGroupOfAccounts', 'account/ledger/subgroup-of-accounts'],
        ['Ledgers', 'account/ledger/ledgers'],

        ['UPI', 'account/pay/makepaymentupi'],
        ['pay-by-wallet', 'account/pay/pay-by-wallet'],
        ['Gateway-Transactions', 'account/pay/Gateway-Transactions'],

        ['Collect', 'account/receipts/collect'],
        ['Approve-Confirm', 'account/receipts/approve'],

        ['refunds', 'account/refunds/refunds'],

        ['AccountStatement', 'account/statements/account-statement'],
        ['TrialBalance', 'account/statements/trial-balance'],
        ['P&LStatement', 'account/statements/p-&-l-statement'],
        ['BalanceSheet', 'account/statements/balance-sheet'],
        ['digital-receipts', 'account/statements/digital-receipts'],

        ['ReceiptVoucher', 'account/vouchers/receipt-voucher'],
        ['PaymentsVoucher', 'account/vouchers/payment-voucher'],
        ['JournalVoucher', 'account/vouchers/journal-voucher'],
        ['ContraVoucher', 'account/vouchers/contra-voucher'],

        ['Ratios', 'account/statements/ratios'],
        ['CashFlow', 'account/statements/cash-flow'],
        ['FundsFlow', 'account/statements/funds-flow'],
        ['Day-Book', 'account/statements/Day-Book'],

        //Gst
        ['ExemptedDeliveryChallan', 'gst/delivery-challan/exempted-delivery-challan'],
        ['TaxableDeliveryChallan', 'gst/delivery-challan/taxable-delivery-challan'],
        ['ExemptedReceiptChallan', 'gst/delivery-challan/exempted-receipt-challan'],
        ['TaxableReceiptChallan', 'gst/delivery-challan/taxable-receipt-challan'],

        ['HSNWiseTaxReport', 'gst/gst-reports/HSN-wise-Tax-Report'],
        ['ITCSummary', 'gst/gst-reports/itc-summary-report'],
        ['Supplier-wiseTaxReport', 'gst/gst-reports/supplier-wise-tax-report'],
        ['TaxRate-wiseTaxReport', 'gst/gst-reports/tax-rate-wise-tax-report'],
        ['Customer-wiseTaxReport', 'gst/gst-reports/customer-wise-tax-report'],
        ['ReverseChargesReport', 'gst/gst-reports/reverse-charges-report'],
        ['Month-wiseTaxSummary', 'gst/gst-reports/month-wise-tax-summary'],



        //Resource Control
        ['ViewAssets', 'resource-control/asset/view-asset'],

        ['Agreements', 'resource-control/compliance/agreement'],
        ['Licences', 'resource-control/compliance/license'],
        ['Contracts', 'resource-control/compliance/contract'],
        ['Permits', 'resource-control/compliance/permit'],
        ['Insurance', 'resource-control/compliance/insurance'],

        ['Booking', 'resource-control/facility-manager/booking'],
        ['Schedule-Update', 'resource-control/facility-manager/schedule-update'],
        ['Request-Material', 'resource-control/facility-manager/request-material'],

        ['Issue', 'resource-control/maintenance/issue'],
        ['ResolveIssue', 'resource-control/maintenance/resolution'],

        ['PerformanceCalendar', 'resource-control/performance/perfomance-calendar'],
        ['PerformanceUpdate', 'resource-control/performance/perfomance-update'],

        ['WarrantyClaims', 'resource-control/warranty/warranty-claims'],
        ['WarrantyManager', 'resource-control/warranty/warranty-manager'],

        //Security
        ['MaterialInwards', 'security/material/materialinwards'],
        ['MaterialOutwards', 'security/material/materialoutwards'],

        ['Vendor', 'security/vendor/vendor'],
        ['Appointment-Visitor', 'security/visitor/visitor-appointment'],
        ['Visits', 'security/visitor/visits'],

        //MessageCenter
        ['emailMessage', 'message-center/messaging/email-communication'],
        ['whatsApp', 'message-center/messaging/whatsapp-communication'],
        ['whatsapp-dashboard', 'message-center/messaging/whatsapp-dashboard'],
        ['KaizalaMessage', 'message-center/messaging/kaizalaMessage'],
        ['LetsMeet', 'message-center/messaging/meet'],
        ['CreateNotification', 'message-center/messaging/create-notification'],
        ['view-notification', 'message-center/messaging/view-notification'],

        //Crm
        ['Track-Screen', 'crm/digiboard/track-screen'],
        ['Screen-Onboard', 'crm/digiboard/screen-onboard'],
        ['Manage-Content', 'crm/digiboard/manage-content'],
        ['Manage-Playlist', 'crm/digiboard/manage-playlist'],

        ['Buy1Get1Free', 'crm/promotions/buy1-get1-free'],
        ['BuyXamountGetYitemfree', 'crm/promotions/buyx-amt-gety-item-free'],
        ['BuyXamountGetYPercentageOff', 'crm/promotions/buyx-amt-gety-percentage-off'],
        ['BuyXamountGetitemX%offonNextBill', 'crm/promotions/buyx-amt-getx-off-bill'],
        ['BuyXGetYPercentageOff', 'crm/promotions/buyx-gety-percentage-off'],
        ['BuyXGetYFree', 'crm/promotions/buyx-gety-free'],
        ['Quantity-BulkDiscount', 'crm/promotions/bulk-discount'],
        ['ValueDiscountonBillAmount', 'crm/promotions/value-discounton-bill-amount'],
        ['Festival-Coupons', 'crm/promotions/festival-coupon'],
        ['Franchise-Lead', 'crm/promotions/franchise-lead'],
        ['SpinToWin-Setup', 'crm/promotions/spin-to-win-setup'],

        ['Assesment', 'crm/survey/assesment'],
        ['Survey', 'crm/survey/survey'],

        ['mto-calculator', 'crm/tools/mto-calculator'],
        ['route-optimiser', 'crm/tools/route-optimiser'],
        ['Tally-Connector', 'crm/tools/import-export'],
        ['Bulk-Entry', 'crm/tools/bulk-entry'],
        ['file-conversion', 'crm/tools/file-conversion'],

        ['Wallet-Credits', 'crm/wallet/wallet-credits'],
        ['Wallet-Offers', 'crm/wallet/wallet-offers'],

        ['Wishlist', 'crm/web-commerce/wishlist'],
        ['Cart', 'crm/web-commerce/cart'],
        ['webuser-info', 'crm/web-commerce/webuser-info'],
        ['Web-Product-Info', 'crm/web-commerce/web-product-info'],

        ['Manage-Issues', 'crm/feedback-manager/manage-issues'],

        //Admin
        ['applications', 'admin/app-setup/applications'],
        ['app-users', 'admin/app-setup/app-users'],

        ['Business', 'admin/business-setup/business-setup'],
        ['BankSetup', 'admin/business-setup/bank-setup'],
        ['online-payment-setup', 'admin/business-setup/online-payment-setup'],

        ['KaizalaSetUp', 'admin/communication-setup/kaizala-setup'],
        ['AWSCredentialSetUp', 'admin/communication-setup/aws-credential-setup'],
        ['CommunicationSetUp', 'admin/communication-setup/communication-setup'],
        ['EMail-Setup', 'admin/communication-setup/email-setup'],
        ['WhatsApp-Setup', 'admin/communication-setup/whatsapp-setup'],
        ['notification-setup', 'admin/communication-setup/notification-setup'],

        ['feedback-setup', 'admin/crm-setup/feedback-setup'],
        ['luckydraw-setup', 'admin/crm-setup/luckydraw-setup'],

        ['Location-Setup', 'admin/database-setup/location-setup'],
        ['Supplier-Setup', 'admin/database-setup/supplier-setup'],
        ['ServiceMan-Setup', 'admin/database-setup/serviceman-setup'],
        ['Employee-Setup', 'admin/database-setup/employee-setup'],
        ['Customer-Setup', 'admin/database-setup/customer-setup'],
        ['Product-Setup', 'admin/database-setup/product-setup'],

        ['GPS', 'admin/hardware-setup/gps-setup'],

        ['User-Role', 'admin/manage-user/user-role-setup'],
        ['User-Access', 'admin/manage-user/user-access-setup'],
        ['Users', 'admin/manage-user/users-setup'],
        ['UserGroup', 'admin/manage-user/user-group-setup'],

        ['Process', 'admin/master/process'],
        ['Production-Machine', 'admin/master/production-machine'],
        ['Area', 'admin/master/area'],
        ['Assets', 'admin/master/assets'],
        ['Assets-Manager', 'admin/master/assets'],
        ['Bank', 'admin/master/bank'],
        ['Brand', 'admin/master/brand'],
        ['Company', 'admin/master/company'],
        ['Composition', 'admin/master/composition'],
        ['Coupon', 'admin/master/coupon'],
        ['Crate', 'admin/master/crate'],
        ['Customer', 'admin/master/customer'],
        ['Customer-Class', 'admin/master/customerclass'],
        ['Supplier', 'admin/master/supplier'],
        ['Department', 'admin/master/department'],
        ['Designation', 'admin/master/designation'],
        ['Matrix', 'admin/master/matrix'],
        ['Employee', 'admin/master/employee'],
        ['Floor', 'admin/master/floor'],
        ['Group', 'admin/master/group'],
        ['Sales-Channel', 'admin/master/saleschannel'],
        ['Service-Man', 'admin/master/serviceman'],
        ['Storage', 'admin/master/storage'],
        ['Storage-Point', 'admin/master/storagepoint'],
        ['Sub-Group', 'admin/master/subgroup'],
        ['Job-Role', 'admin/master/jobrole'],
        ['Location', 'admin/master/location'],
        ['Location-Type', 'admin/master/location-type'],
        ['Orders-Message-Message-Center', 'admin/master/organiser'],
        ['Organiser-Class', 'admin/master/organiser-class'],
        ['Organiser-Details', 'admin/master/organiser-details'],
        ['Organiser-Location', 'admin/master/organiser-location'],
        ['Organiser', 'admin/master/organiser'],
        ['Product', 'admin/master/product'],
        ['Product-Batch', 'admin/master/productbatch'],
        ['Region', 'admin/master/region'],
        ['City', 'admin/master/city'],
        ['Route', 'admin/master/route'],

        ['MakeToOrderSetUp', 'admin/transaction-setup/maketoorder-setup'],
        ['AssetManagerSetUp', 'admin/transaction-setup/asset-setup'],
        ['FacilityManagerSetUp', 'admin/transaction-setup/facility-manager-setup'],
        ['PurchaseSetUp', 'admin/transaction-setup/purchase-setup'],
        ['Sale-CashRegister', 'admin/transaction-setup/sale-cashregister-setup'],
        ['AccountsSetup', 'admin/transaction-setup/account-setup'],
        ['Billing-InvoicingManagement', 'admin/transaction-setup/billing-management-setup'],
        ['Inventory-Transaction-Manager', 'admin/transaction-setup/inventory-setup'],
        ['SurveySetUp', 'admin/transaction-setup/survey-setup'],
        ['WebOrderSetUp', 'admin/transaction-setup/weborder-setup'],
        ['Shipping&DeliverySetUp', 'admin/transaction-setup/shipping-and-delivery-setup'],
        ['B2BSetup', 'admin/transaction-setup/b2b-setup'],
        ['OrdereManagementSetUp', 'admin/transaction-setup/ordermanagement-setup'],
        ['ProductionSetup', 'admin/transaction-setup/production-setup'],
        ['SecuritySetup', 'admin/transaction-setup/security-setup'],
        ['Google-Api-Key-Setup', 'admin/transaction-setup/google-api-key-setup'],
        ['Backup-Restore', 'admin/backup-restore/backup-and-restore'],
        ['Store-Operation-Setup', 'admin/transaction-setup/store-operation-setup'],
        ['Auto-Setup', 'admin/transaction-setup/auto-setup'],
        ['Internationalization', 'admin/transaction-setup/internationalization'],
        ['PlatformSetUp', 'admin/transaction-setup/platform-setup'],

        //Report
        //Summary Report
        ['Sales-Summary', 'report/summary/sale'],
        ['MakeToOrder-Summary', 'report/summary/maketoorder'],
        ['OrderManagement-Summary', 'report/summary/ordermanagement'],
        ['Production-Summary', 'report/summary/production'],
        ['Purchase-Summary', 'report/summary/purchase'],
        ['GST-Summary-Reports', 'report/summary/gst'],
        ['Inventory-Summary', 'report/summary/inventory'],
        ['Location-Summary', 'report/summary/location'],
        ['Account-Summary-Reports', 'report/summary/account'],
        ['Festival-Coupons-Summary', 'report/summary/festival-coupon'],
        ['Store-Reporting-Summary', 'report/summary/store-reporting'],
        ['Product-History-Summary', 'report/summary/product-history'],
        ['Spin-To-Win-Summary', 'report/summary/spin-and-win'],
        ['HR-Summary-Reports', 'report/summary/hr'],


        //Executive Report
        ['OrderManagement', 'report/executive/ordermanagement'],
        ['MakeToOrder', 'report/executive/maketoorder'],
        ['Purchase', 'report/executive/purchase'],
        ['Sales', 'report/executive/sale'],
        ['Production-Reports', 'report/executive/production'],
        ['Inventory-Executive-Reports', 'report/executive/inventory'],
        ['GST-Executive-Reports', 'report/executive/gst'],
        ['MessageCenter-Executive-Reports', 'report/executive/messagecenter'],
        ['HR-Executive-Reports', 'report/executive/hr-reports'],

        //Detail Report
        ['Sales-Detail', 'report/detail/sale'],
        ['MakeToOrder-Detail', 'report/detail/maketoorder'],
        ['Inventory-Detail', 'report/detail/inventory'],
        ['Purchase-Detail', 'report/detail/purchase'],
        ['OrderManagement-Detail', 'report/detail/ordermanagement'],
        ['Production-Detail', 'report/detail/production'],
        ['HR-Detail-Reports', 'report/detail/hr'],
        ['AssetManagerDetailsReport', 'report/detail/assetmanager'],
        ['GST-Details-Report', 'report/detail/gstreport'],
        ['store-manager-report', 'report/detail/storemanager'],
        ['user-operation', 'report/detail/useroperation'],
        ['feedback-detail', 'report/detail/feedback'],
        ['communication-detail', 'report/detail/communication'],
        ['Festival-Coupons-Detail', 'report/detail/festival-coupon'],
        ['Store-Reporting-Detail', 'report/detail/storereporting'],
        ['Error-Log-Detail', 'report/detail/error-log-report'],
        ['Product-History-Detail', 'report/detail/product-history'],
        ['Spin-To-Win-Details', 'report/detail/spin-to-win'],

        ['Edit Trail', 'report/edit-trail/edit-trail'],
        ['Log', 'report/activity-log/log-report'],
        ['Supplier-Detail', 'report/detail/supplier'],

        //Reconcilliation Report
        ['Reconcilliation', 'report/reconciliation/reconciliation-report'],
        ['OrderManagement-Reconciliation', 'report/reconciliation/ordermanagement'],
        ['Sale-Reconciliation', 'report/reconciliation/sale'],
        ['MakeToOrder-Reconciliation', 'report/reconciliation/make-to-order'],
        ['Inventory-Reconciliation', 'report/reconciliation/inventory'],
        ['Location-Reconciliation', 'report/reconciliation/location'],

        //Shipping
        ['rider-details', 'shipping/rider/rider-details'],
        ['shipping-manager', 'shipping/shippings/manage-delivery'],
        ['Dispute-Resolution', 'shipping/shippings/dispute-resolution'],
        ['ShippingExpenses', 'shipping/shippings/shipping-expenses'],
        ['web-order-confirmation', 'shipping/shippings/web-order-confirmation'],
        ['date-wise-shipping-report', 'shipping/shipping-reports/date-wise-shipping-report'],
        ['shipping-summary-report', 'shipping/shipping-reports/shipping-summary-report'],
        ['LiveLocation', 'shipping/shipping-reports/liveLocation'],

        ['dashboard', 'dashboard'],
        ['monitoring-dashboard', 'monitoring-dashboard'],
        ['Warranty', 'warranty'],
        ['Material-In', 'matrix'],

        ['Cdnur-Purchase-GST', 'city'],

        ['Gatepass', 'gatepass'],
        ['Material-In', 'material-in'],
        ['Permission', 'permission'],


        //Hr
        ['docsetup', 'hr/setup/docsetup'],
        ['companydocs', 'hr/setup/companydocs'],
        ['statutorySetUp', 'hr/setup/statutorySetUp'],
        ['payrollSetup', 'hr/setup/payrollSetup'],
        ['taxSetup', 'hr/setup/taxSetup'],
        ['empGroups', 'hr/setup/empGroups'],
        ['jdSetUp', 'hr/setup/jdSetUp'],
        ['scheduleSetUp', 'hr/setup/scheduleSetUp'],
        ['overTimeSetUp', 'hr/setup/overTimeSetUp'],
        ['attendanceSetUp', 'hr/setup/attendanceSetUp'],
        ['leaveSetUp', 'hr/setup/leaveSetUp'],
        ['expenseSetUp', 'hr/setup/expenseSetUp'],
        ['loanSetUp', 'hr/setup/loanSetUp'],
        ['pmsSetUp', 'hr/setup/pmsSetUp'],
        ['foodCouponSetUp', 'hr/setup/foodCouponSetUp'],
        ['exitSetUp', 'hr/setup/exitSetUp'],
        ['accommodationSetUp', 'hr/setup/accommodationSetUp'],
        ['hoildaySetUp', 'hr/setup/hoildaySetUp'],
        ['encashmentSetUp', 'hr/setup/encashmentSetUp'],
        ['signatorySetUp', 'hr/setup/signatorySetUp'],
        ['Biometric-SetUp', 'hr/setup/biometricSetUp'],
        ['gratuitySetUp', 'hr/setup/gratuitySetUp'],

        ['appraisal', 'hr/appraisal/appraisal'],
        ['issueResolution', 'hr/appraisal/issueResolution'],

        ['employment', 'hr/enrollment/employment'],
        ['personal', 'hr/enrollment/personal'],
        ['education', 'hr/enrollment/education'],
        ['experience', 'hr/enrollment/experience'],
        ['empStatutory', 'hr/enrollment/empStatutory'],
        ['reference', 'hr/enrollment/reference'],
        ['bgCheck', 'hr/enrollment/bgCheck'],
        ['documents', 'hr/enrollment/documents'],
        ['letters', 'hr/enrollment/letters'],
        ['salary', 'hr/enrollment/salary'],
        ['attendance', 'hr/enrollment/attendance'],
        ['leaveLoanExpense', 'hr/enrollment/leaveLoanExpense'],
        ['leave', 'hr/enrollment/leave'],
        ['loan', 'hr/enrollment/loan'],
        ['expense', 'hr/enrollment/expense'],
        ['performanceSetUp', 'hr/enrollment/performanceSetUp'],
        ['foodCouponAllocate', 'hr/enrollment/foodCouponAllocate'],
        ['assetAllocation', 'hr/enrollment/assetAllocation'],
        ['accomodation', 'hr/enrollment/accomodation'],
        ['setKRA', 'hr/enrollment/setKRA'],
        ['enrollmentMasterData', 'hr/enrollment/enrollmentMasterData'],

        ['markAttendance', 'hr/attendance/markAttendance'],
        ['manualAttendance', 'hr/attendance/manualAttendance'],
        ['systemAttendance', 'hr/attendance/systemAttendance'],
        ['attendanceCorrection', 'hr/attendance/attendanceCorrection'],
        ['attendanceRegularization', 'hr/attendance/attendanceRegularization'],

        ['requestLeave', 'hr/leave/requestLeave'],

        ['requestLoan', 'hr/loans/requestLoan'],
        ['approveLoanRequest', 'hr/loans/approveLoanRequest'],

        ['TrackEmployee', 'hr/track/trackEmployee'],

        ['advanceForExpense', 'hr/expense/advanceForExpense'],
        ['requestExpenseClaim', 'hr/expense/requestExpenseClaim'],

        ['salaryProcessing', 'hr/payroll/salaryProcessing'],
        ['tdsCalculation', 'hr/payroll/tdsCalculation'],
        ['overtimeCalculation', 'hr/payroll/overtimeCalculation'],
        ['incentiveCalculation', 'hr/payroll/incentiveCalculation'],
        ['bonusCalculation', 'hr/payroll/bonusCalculation'],
        ['claims', 'hr/payroll/claims'],
        ['deduction', 'hr/payroll/deduction'],
        ['reimbursements', 'hr/payroll/reimbursements'],
        ['arrears', 'hr/payroll/arrears'],
        ['leaveEncashments', 'hr/payroll/leaveEncashments'],
        ['paySlips', 'hr/payroll/paySlips'],
        ['incomeTax', 'hr/payroll/incomeTax'],
        ['gratuity', 'hr/payroll/gratuity'],
        ['form16', 'hr/payroll/form16'],

        ['messaging', 'hr/communication/messaging'],

        ['couponReport', 'hr/food-coupon/couponReport'],

        ['postRequirement', 'hr/recruitment/postRequirement'],
        ['cvBank', 'hr/recruitment/cvBank'],
        ['shortlist', 'hr/recruitment/shortlist'],
        ['scheduleInterview', 'hr/recruitment/scheduleInterview'],
        ['interviewFeedback', 'hr/recruitment/interviewFeedback'],
        ['confirmation', 'hr/recruitment/confirmation'],

        ['initiateExit', 'hr/exit/initiateExit'],
        ['exitInterview', 'hr/exit/exitInterview'],
        ['exit', 'hr/exit/exit'],

        ['Package-Setup', 'subscription/subscription/package-setup'],
        ['Subscription-Plan', 'subscription/subscription/subscription-plan'],
        ['Subscription-Activation-Deactivation', 'subscription/subscription/subscription-activation-deactivation'],

    ]);

    public getUrl(subModuleUrl: string, isAndroid: boolean): string {
        if (isAndroid && subModuleUrl == 'POS') {
            subModuleUrl = 'POS-android';
        }
        return this.map.get(subModuleUrl) || "page-not-found";
    }

    public getInternalNameByUrl(url: string, isAndroid: boolean): string {
        if (isAndroid && url == 'sale/pos/pos-web-app') {
            url = 'sale/pos/pos';
        }
        for (const [key, val] of this.map.entries()) {
            if (val === url) {
                return key;
            }
        }
        return undefined;
    }
}
